export { LinkAppToParentProduct } from './link-app-to-parent-product';
